import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const Description = styled.div`
  display: block;
  margin-bottom: 20px;
  font-size: 14px;
  color: ${colors['black-six']};
  line-height: 1;
  text-align: left;
`;

export default Description;
